"use client";

import type { DistrictName } from "@nimble/datamodel/types/district";
import type { DistrictNcesId } from "@nimble/datamodel/types/ncesId";
import Link from "next/link";

import { useClientFeatureFlag } from "@/hooks/use-client-feature-flag";
import { useIsClient } from "@/hooks/use-is-client";
import routes from "@/lib/routes";
import { StateConfig } from "@/lib/states-config";

export default function DistrictNameLink({
  districtId,
  districtName,
  stateConfig,
}: {
  districtId: DistrictNcesId;
  districtName: DistrictName;
  stateConfig: StateConfig;
}) {
  const isClient = useIsClient();
  const isDistrictBoardEnabled = useClientFeatureFlag("district_job_board_m1");

  if (!isClient || !isDistrictBoardEnabled) {
    return <>{districtName}</>;
  }

  return (
    <Link
      href={routes.getDistrict({ state: stateConfig, districtId })}
      className="cursor-pointer text-inherit hover:text-primary hover:underline transition-colors"
    >
      {districtName}
    </Link>
  );
}
